import "./User.css";
import React from "react";
import CarteProfile from '../../../Component/CarteProfile/CarteProfile';
import ProfPage from './ProfPage/ProfPage';
import FilDarian from "../../../Component/FilDarian/FilDarian";
import { Outlet } from "react-router-dom";
import { USERS_ADMIN_NAVIGATION_ETUDIANTS } from "../../../Routes/NAVIGATION_PATH";

function template() {
  const user_navigation = {
    nom1: 'Professeurs',
    nom2: 'Etudiants',
    route1: '',
    route2:USERS_ADMIN_NAVIGATION_ETUDIANTS
  }
  return (
    <div className="user">
      <FilDarian
      nom1={user_navigation.nom1}
      nom2={user_navigation.nom2}
      route1={user_navigation.route1}
      route2={user_navigation.route2}
      />
      <Outlet/>
    </div>
  );
};

export default template;
